<mat-form-field class="me-3">
  <input
    matInput
    placeholder="Search For a Unit"
    name="densityUnitsControl"
    [matAutocomplete]="densityAuto"
    [formControl]="unitsControl"
    [(ngModel)]="density.unit"
    (blur)="checkSelection()"
  />
  <mat-autocomplete #densityAuto="matAutocomplete">
    @for (unit of filteredUnits; track unit) {
      <mat-option [value]="unit.id">
        {{ unit.name }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>

<mat-form-field class="me-3">
  <input matInput placeholder="score" [(ngModel)]="density.score" />
</mat-form-field>

<button
  type="button"
  mat-raised-button
  color="accent"
  class="mx-auto"
  [disabled]="!density.unit || !density.score"
  (click)="getBridgeDensity()"
>
  Get Report
</button>
@if (bridgeDensityData.data) {
  <button
    type="button"
    mat-button
    color="primary"
    class="grid-button pull-right"
    [disabled]="!bridgeDensityData.data"
    (click)="exportToExcel(bridgeDensityGrid)"
  >
    <mat-icon>cloud_download</mat-icon>Download Excel File
  </button>
}
<kendo-grid
  #bridgeDensityGrid="kendoGrid"
  class="col-12 mt-3 usage-grid"
  [hidden]="!bridgeDensityData.data"
  [kendoGridBinding]="bridgeDensityData.data"
  [height]="600"
  [selectable]="true"
  [navigable]="true"
>
  @for (col of bridgeDensityData.headers; track col) {
    <kendo-grid-column [field]="col.DataField" [title]="col.Label" />
  }
  <kendo-grid-excel fileName="RightBridge-BridgeDensityReport.xlsx" />
</kendo-grid>
